export default function Invite() {
  return (
    <div>
      <p>
        Zaproś znajomych! <br />
        Użyj linku polecającego, aby zaprosić dowolną liczbę osób.
      </p>
      <br />
      <p>Funkcjonalność jest w budowie.</p>
    </div>
  );
}
